import { useContext } from 'react';

import { ReturnUrlContext } from '../../ReturnUrlContext';

export const useSetReturnUrl = () => useContext(ReturnUrlContext).setReturnUrl;
